import React from "react";
import { useNavigate } from "react-router-dom";
import { HiArrowLeft, HiTrophy } from "react-icons/hi2";
import { useUserPoints } from "../../services/pointsService";
import Header from "../../components/layout/Header";
import STAXS from "../../assets/stax.png";
import ActivationComponent from "../../components/staxs/activationComponent";
import { HiChevronLeft } from "react-icons/hi2";

const EQLXSettings: React.FC = () => {
  const navigate = useNavigate();
  const { points, loading, error } = useUserPoints();

  return (
    <div className="w-full pt-16 px-8">
      <Header />
      <div className="container max-w-2xl mx-auto pt-8 pb-4">
        {/* Header */}
        <div className="flex items-center mb-2">
          <button
            onClick={() => navigate("/settings")}
            className="flex items-center p-2 bg-base-300 rounded-full hover:bg-base-300 transition-colors mr-4"
          >
            <HiChevronLeft className="h-6 w-6 text-base-content" />
          </button>
          <img src={STAXS} alt="EQLX Logo" className="w-32 mr-3" />
          <h1 className="text-3xl font-semibold text-base-content/60 font-grotesk">
            Points
          </h1>
        </div>
      </div>
      {/* Points Display Card */}
      <div className="max-w-2xl mx-auto bg-base-100 rounded-lg shadow-sm border border-base-300 p-8 mb-4">
        <div className="">
          <div className="max-w-2xl bg-base-300 rounded-md shadow-sm border border-base-300 p-8 mb-6 mx-auto">
            <div className="flex items-center">
              <div className="rounded-md">
                {loading ? (
                  <div className="text-4xl font-bold text-base-content/50">
                    Loading...
                  </div>
                ) : error ? (
                  <div className="text-4xl font-bold text-red-500">Error</div>
                ) : (
                  <div className="text-4xl font-bold text-base-content">
                    {points}
                    <span className="text-4xl text-base-content/60 ml-1 font-grotesk">
                      ^
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-lg font-grotesk">What is STAXS??</h2>
        <p className="pb-4 font-grotesk">
          Earn points for logging data consistenly.
        </p>
        <p className="text-sm">
          STAXS is a sports data network that allows your to translate your
          sports data into a digital asset you own using blockchain technology.
          <br></br>
          <br></br>
          STAXS is being built into the foundations of PEAK^ to give you
          ownership and control over your data.
        </p>
        <p className="text-base-content/60 text-sm py-4">
          Stay tuned, more information coming soon...
        </p>

        {/* Activation Component */}
        <div className="pt-4 ">
          <button
            disabled
            className="px-6 py-3 w-full bg-indigo-600 text-white text-grotesk rounded-lg hover:bg-indigo-700 transition-colors font-medium"
          >
            Activation Coming Soon...
          </button>
          {/* <ActivationComponent /> */}
        </div>
        <div className="px-4">
          {/* <button
            onClick={() => navigate("/staxs")}
            className="px-6 py-3 w-full bg-neutral text-white text-grotesk rounded-lg hover:bg-indigo-700 transition-colors font-medium"
          >
            Enter Portal (Coming Soon)
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default EQLXSettings;
